import { Play } from "lucide-react";
import { ENVIRONMENT_VIDEOS } from "@/data/environment";

const YT_EMBED_PARAMS =
    "rel=0&modestbranding=1&playsinline=1&iv_load_policy=3&fs=1&autoplay=0";

function youtubeEmbedSrc(id) {
    return `https://www.youtube-nocookie.com/embed/${id}?${YT_EMBED_PARAMS}`;
}

function YouTubeCard({ video }) {
    return (
        <article className="rounded-2xl border border-white/10 bg-zinc-900 overflow-hidden shadow-lg shadow-black/20">
            <div className="relative w-full aspect-video min-h-[220px] sm:min-h-[320px] md:min-h-[380px] bg-black [transform:translateZ(0)]">
                <iframe
                    src={youtubeEmbedSrc(video.id)}
                    title={video.title}
                    className="absolute inset-0 h-full w-full border-0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                />
            </div>
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 px-4 py-3 border-t border-white/10 bg-zinc-950/80">
                <p className="text-sm font-medium text-white/90">{video.title}</p>
                <a
                    href={video.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 text-xs font-mono uppercase tracking-wider text-emerald-400 hover:text-emerald-300 transition-colors shrink-0"
                >
                    <Play className="h-3.5 w-3.5" />
                    YouTube
                </a>
            </div>
        </article>
    );
}

export default function EnvironmentMedia() {
    return (
        <div className="mb-12 sm:mb-16 [transform:translateZ(0)]">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8">
                {ENVIRONMENT_VIDEOS.map((video) => (
                    <YouTubeCard key={video.id} video={video} />
                ))}
            </div>
        </div>
    );
}
